<template>
    <div class="comScreenDP chartConfig_viewDP">
        <div class="chartDivConfig numViewConfig numViewConfig_unit">
            <span class="span_til">页面宽度</span>
            <el-input v-model="pageSize.width" type="number" readonly></el-input>
            <div class="unit">px</div>
        </div>
        <div class="chartDivConfig numViewConfig numViewConfig_unit">
            <span class="span_til">页面高度</span>
            <el-input v-model="pageSize.height" type="number" readonly></el-input>
            <div class="unit">px</div>
        </div>
    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/5/9 3:01 下午
     */
    export default {
        name: 'comScreenDP',
        components: {},
        props: {},
        data() {
            return {}
        },
        computed: {
            pageSize() {
                return this.$store.state.designer.pageSize;
            },
        },
        methods: {},
        mounted() {

        },
        destroyed() {

        }
    }
</script>

<style lang="less">
    .comScreenDP {

    }
</style>